import { AB23CD } from './AB23CD';
import { BC23DE } from './BC23DE';
import { CD23EF } from './CD23EF';
import { DE23FG } from './DE23FG';
import { EF23GH } from './EF23GH';
import { FG23HI } from './FG23HI';

export const fixtures = {
  AB23CD, // Customer only has european upgrade vouchers
  BC23DE, // Customer only has upgrade benefits
  CD23EF, // Customer has both european upgrade vouchers and upgrade benefits
  DE23FG, // OUL - HEL - SIN return 3 pax all vouchers
  EF23GH, // OUL - HEL - SIN return 2 pax, no long haul vouchers
  FG23HI, // Old API, no upgrade benefits in payment options
};
